import StaticPageHeader from "../../Common/StaticPageHeader";
import { Link } from "react-router-dom";

const Faq = () => {
  return (
    <>
      <StaticPageHeader />
      <div className="container my-3">
        <div className="my-4">
          <span className="d-flex gap-2 justify-content-start align-items-center fw-bold">
            <Link to="/">
              <img className="me-2 cursor-pointer" src="home.svg" alt="home" />
            </Link>
            &gt; <span className="ms-2">FAQ</span>
          </span>
        </div>
        <div className="row">
          <div className="col-12  mb-4">
            <h2>Frequently Asked Questions (FAQ)</h2>
          </div>

          <div className="col-md-12">
            <div className="card  border-0">
              <div className="">
                <h5 className="mb-2">
                  1. What types of lighting solutions do you offer?
                </h5>
                <p className="mb-4">
                  We specialize in LED lighting, flood lights, high mast
                  lighting, and customized solutions for industrial, commercial,
                  and outdoor applications.
                </p>

                <h5 className="mb-2">
                  2. Do you provide customized lighting solutions?
                </h5>
                <p className="mb-4">
                  Yes. We understand that every project is different, so we
                  offer tailored lighting solutions based on your specific
                  requirements.
                </p>

                <h5 className="mb-2">3. Are your products energy-efficient?</h5>
                <p className="mb-4">
                  Absolutely. Our focus is on energy-efficient LED systems that
                  help reduce electricity costs while maintaining high
                  performance.
                </p>

                <h5 className="mb-2">4. Do you handle large-scale projects?</h5>
                <p className="mb-4">
                  Yes, we work on both small and large-scale projects, including
                  industrial setups, infrastructure lighting, and commercial
                  installations.
                </p>

                <h5 className="mb-2">
                  5. How can I choose the right lighting for my project?
                </h5>
                <p className="mb-4">
                  You can get in touch with our team, and we’ll guide you based
                  on your space, usage, and budget to ensure the best solution.
                </p>

                <h5 className="mb-2">
                  6. Do your products come with a warranty?
                </h5>
                <p className="mb-4">
                  Yes, most of our products come with a warranty. The duration
                  depends on the product type and will be shared during
                  purchase.
                </p>

                <h5 className="mb-2">7. How long does delivery take?</h5>
                <p className="mb-4">
                  Delivery timelines vary depending on the order size and
                  location, but we always aim for timely dispatch and delivery.
                </p>

                <h5 className="mb-2">
                  8. Can I request a quote before placing an order?
                </h5>
                <p className="mb-4">
                  Of course. You can contact us with your requirements, and
                  we’ll provide a detailed quotation.
                </p>

                <h5 className="mb-2">9. Do you offer after-sales support?</h5>
                <p className="mb-4">
                  Yes, we believe in long-term relationships and provide support
                  even after the purchase is complete.
                </p>

                <h5 className="mb-2">
                  10. How can I contact Trex Lighting Solutions?
                </h5>
                <p>
                  You can reach out via our website contact form, email, or
                  phone number provided on the site.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Faq;